import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { useNotification } from '../../providers/notificationsProvider';
import { API_URL, getCachedSessionId } from '../../services/common';

const createCpanel = async ({
  domainName,
  email,
  aRecord,
  cnameRecord,
  autoSetting,
  projectId
}) => {
  const data = JSON.stringify({
    aRecord,
    autoSetting,
    cnameRecord,
    domainName,
    email
  });

  // var data = JSON.stringify({
  //   "domainName": domainName,
  //   "email": email,
  // });
  // const response = await axios.post(
  //   `${API_URL}/v1/project/${projectId}/provider/hosting/cpanel/`,

  //   {
  //     headers: {
  //       'x-session-id': 'b58a89a7-468d-40c2-a3c4-42efe08361ed',
  //       'Content-Type': 'application/json'
  //     },
  //     data : data
  //   },
  // )

  const config = {
    data,
    headers: {
      'Content-Type': 'application/json',
      'x-session-id': getCachedSessionId()
    },
    method: 'post',
    url: `${API_URL}/v1/project/${projectId}/provider/hosting/cpanel/`
  };

  const responseData = [];

  await axios(config)
    .then((response) => {
      responseData.push(response);
    })
    .catch((error) => {
      const { notify } = useNotification();
      notify({ message: error.message, severity: 'error' });
    });
  return responseData[0].data;
};

export const useCreateCpanel = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotification();
  return useMutation(createCpanel, {
    onError: (error) => {
      notify({ message: error.message, severity: 'error' });
    },
    onSuccess: () => {
      notify({ message: 'Cpanel was created successfully', severity: 'success' });
      queryClient.invalidateQueries(['cPanel']);
    }
  });
};
